

<template>

<router-link :to="to" v-slot="{ href, route, navigate, isActive, isExactActive }">
    <li class="text-xl leading-none">
        <a v-if="enabled" :href="href" @click="navigate" :class="[isExactActive ? 'text-white' : inactiveClasses, defaultClasses]">
        {{name}}
      </a>
        <span v-else :class="[defaultClasses, 'cursor-not-allowed opacity-40']">{{name}}</span>
    </li>
</router-link>

</template>

<script>

export default {
    name: 'NavBarLink',
    props: {
        to: {
            type: String,
            required: true
        },
        name: {
            type: String,
            required: true
        },
        enabled: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        defaultClasses() {
                return "block py-6 w-full text-center";
            },

            inactiveClasses() {
                return "opacity-100 hover:opacity-40";
            }
    }
}

</script>
